import { jsx, Fragment, jsxs } from 'react/jsx-runtime';
import { forwardRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { IconButton } from '@skatteetaten/ds-buttons';
import { dsI18n, getCommonClassNameDefault } from '@skatteetaten/ds-core-utils';
import { InfoSquareSVGpath, WarningSVGpath, ErrorSVGpath, Icon, CancelSVGpath } from '@skatteetaten/ds-icons';
import { Heading } from '@skatteetaten/ds-typography';
import './CardAlert/styles.css';


const getCardAlertVariantDefault = ()=>'warning';
const getCardAlertSvgPathDefault = (variant)=>{
    switch(variant){
        case 'warning':
            return ErrorSVGpath;
        case 'danger':
            return WarningSVGpath;
        case 'neutral':
        default:
            return InfoSquareSVGpath;
    }
};
const getCardAlertTitleAsDefault = ()=>'h3';

var styles = {
    "cardAlert": "CardAlert-module_cardAlert__5Z0FQ",
    "cardAlertIcon": "CardAlert-module_cardAlertIcon__7xNa3",
    "cardAlertArrow": "CardAlert-module_cardAlertArrow__8fBA6",
    "cardAlertCloseButton": "CardAlert-module_cardAlertCloseButton__3x02t",
    "cardAlertHeadingContainer": "CardAlert-module_cardAlertHeadingContainer__dGAYA"
};

const CardAlert = /*#__PURE__*/ forwardRef(({ id, className = getCommonClassNameDefault(), lang, 'data-testid': dataTestId, title, titleAs = getCardAlertTitleAsDefault(), variant = getCardAlertVariantDefault(), svgPath = getCardAlertSvgPathDefault(variant), showAlert: showAlertExternal, onClose, children }, ref)=>{
    const { t } = useTranslation('Shared', {
        i18n: dsI18n
    });
    const [showAlertInternal, setShowAlertInternal] = useState(true);
    const showAlert = showAlertExternal !== undefined ? showAlertExternal : showAlertInternal;
    if (!showAlert) {
        return /*#__PURE__*/ jsx(Fragment, {
            children: " "
        });
    }
    return /*#__PURE__*/ jsxs("div", {
        ref: ref,
        id: id,
        className: `${styles.cardAlert} ${className}`.trim(),
        lang: lang,
        "data-testid": dataTestId,
        "data-variant": variant,
        children: [
            /*#__PURE__*/ jsxs("div", {
                className: styles.cardAlertHeadingContainer,
                children: [
                    /*#__PURE__*/ jsx(Icon, {
                        className: styles.cardAlertIcon,
                        svgPath: svgPath
                    }),
                    /*#__PURE__*/ jsx(Heading, {
                        level: 5,
                        as: titleAs,
                        children: title
                    }),
                    /*#__PURE__*/ jsx(IconButton, {
                        className: styles.cardAlertCloseButton,
                        svgPath: CancelSVGpath,
                        title: t('shared.Close'),
                        onClick: ()=>{
                            setShowAlertInternal(false);
                            onClose?.();
                        }
                    })
                ]
            }),
            children,
            /*#__PURE__*/ jsx("div", {
                className: styles.cardAlertArrow
            })
        ]
    });
});

export { CardAlert as C, getCardAlertSvgPathDefault as a, getCardAlertTitleAsDefault as b, getCardAlertVariantDefault as g };
